var _path, _path2, _circle, _circle2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSad = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.6667C11.6818 14.6667 14.6666 11.6819 14.6666 8.00004C14.6666 4.31814 11.6818 1.33337 7.99992 1.33337C4.31802 1.33337 1.33325 4.31814 1.33325 8.00004C1.33325 11.6819 4.31802 14.6667 7.99992 14.6667Z",
    stroke: "#C90000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.29943 11.4478C4.04683 11.319 3.9441 11.008 4.09976 10.771C4.47574 10.1987 4.97433 9.71432 5.56175 9.35435C6.29557 8.90466 7.13944 8.66667 8.00008 8.66667C8.86072 8.66667 9.70459 8.90466 10.4384 9.35435C11.0258 9.71432 11.5244 10.1987 11.9004 10.771C12.0561 11.008 11.9533 11.319 11.7007 11.4478C11.4481 11.5765 11.1418 11.4733 10.9789 11.2413C10.6939 10.8355 10.3279 10.4907 9.90198 10.2297C9.3296 9.87897 8.67138 9.69333 8.00008 9.69333C7.32878 9.69333 6.67056 9.87897 6.09819 10.2297C5.6723 10.4907 5.30629 10.8355 5.0213 11.2413C4.85836 11.4733 4.55204 11.5765 4.29943 11.4478Z",
    fill: "#C90000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.33325,
    cy: 7.66663,
    r: 1,
    fill: "#C90000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6667,
    cy: 7.66663,
    r: 1,
    fill: "#C90000"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSad, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sad.f47d3eb7.svg";
export { ForwardRef as ReactComponent };